import React from 'react';
import {
  get, sortBy, map, indexOf, includes, filter,
} from 'lodash';
import { Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import { connect } from 'react-redux';

import { getMarketName } from '../../lib/utils';
import CustomToolbar from './custom-toolbar';

const styles = {
  root: {
    width: '50%',
    margin: '0 auto',
  },
};

class EditMarketTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      marketPreferences: props.marketPreferences || [],
      editing: false,
    };

    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  onSave() {
    this.props.handleSave(this.state.marketPreferences);
    this.setState({ editing: false });
  }

  onCancel() {
    this.props.handleCancel();
  }

  get markets() {
    const allMarkets = get(this, 'props.markets', []);

    return sortBy(
      allMarkets,
      (market) => getMarketName(market).toLowerCase(),
    );
  }

  get user() {
    const user = get(this, 'props.location.state.user');
    return user;
  }

  get marketPreferences() {
    const { marketPreferences } = this.state;
    const allMarkets = this.markets;
    const allMarketsIds = map(allMarkets, (market) => market._id);
    const marketPrefsByOverallIndex = sortBy(
      map(marketPreferences, (market) => indexOf(allMarketsIds, market)),
    );
    return marketPrefsByOverallIndex;
  }

  get tableOptions() {
    const options = {
      filter: false,
      search: false,
      download: false,
      print: false,
      viewColumns: false,
      rowsSelected: this.marketPreferences,
      onRowSelectionChange: (currentRowsSelected, allRowsSelected) => {
        const allSelectedRowsIndex = map(allRowsSelected, (row) => row.index);
        const selectedMarketIds = map(
          filter(this.markets, (market, index) => includes(allSelectedRowsIndex, index)),
          (market) => market._id,
        );
        this.setState({ marketPreferences: selectedMarketIds, editing: true });
      },
      customToolbarSelect: () => {
        const { editing } = this.state;

        return (
          <div>
            <CustomToolbar
              type="Cancel"
              onClick={this.onCancel}
            />
            {editing
              && (
              <CustomToolbar
                type="Save"
                onClick={this.onSave}
              />
              )}
          </div>
        );
      },
    };

    return options;
  }

  render() {
    const columns = [
      {
        name: 'ID',
        options: {
          display: 'excluded',
          filter: false,
        },
      },
      {
        name: 'Name',
      },
    ];

    return (
      <Grid style={styles.root}>
        <MUIDataTable
          title="Select Markets"
          columns={columns}
          data={this.markets.map((market) => (
            [
              get(market, '_id', ''),
              getMarketName(market),
            ]
          ))}
          options={this.tableOptions}
        />
      </Grid>
    );
  }
}

const mapStateToProps = ({ markets }) => ({
  markets: markets.markets,
});

export default connect(mapStateToProps, undefined)(EditMarketTable);
